import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "NativeNewOutlookTeachingCallout" */ "./lazyIndex"), { name: "NativeNewOutlookTeachingCallout" });

export const AutoToggleTeachingCallout: typeof lazyIndex.AutoToggleTeachingCallout = createLazyComponent(lazyModule, m => m.AutoToggleTeachingCallout);
